import { useMutation } from '@tanstack/react-query';

import {
  REQUEST_HEIDI_2_ACCESS_MUTATION_KEY,
  type RequestHeidi2AccessResponse,
} from '../../contracts';
import { requestHeidi2Access } from '../api/billing';

export type UseMutateRequestHeidi2AccessVariables = {
  message?: string;
};

export type UseMutateRequestHeidi2AccessProps = {
  onRequested?: (response: RequestHeidi2AccessResponse) => void;
  onRequestError?: (error: unknown) => void;
};

export function useMutateRequestHeidi2Access({
  onRequested,
  onRequestError,
}: UseMutateRequestHeidi2AccessProps = {}) {
  return useMutation<
    RequestHeidi2AccessResponse,
    unknown,
    UseMutateRequestHeidi2AccessVariables
  >({
    mutationKey: [REQUEST_HEIDI_2_ACCESS_MUTATION_KEY],
    mutationFn: async ({ message }) => {
      const { data } = await requestHeidi2Access({ message });
      return data;
    },
    onSuccess: (data) => onRequested?.(data),
    onError: (error) => onRequestError?.(error),
  });
}
